import { Injectable } from '@angular/core';
import { DataTransformAbstractGet } from 'app/modules/global/classes/data.transform.abstract.up';
import { PlaylistItemNestedInterface, PlaylistItemInterface } from 'app/modules/editorial/editorial.interface';
import {
  TimeslotInterface,
  TimeslotsCalendarInterface,
  WeeklySchedulingInterface,
} from 'app/modules/common/timeslot/timeslot.interface';
import { DistributionInterface } from 'app/models/distribution.model';
import { DateRangeInterface } from 'app/modules/common/datetime/dateslots/dateslot.interface';

@Injectable({
  providedIn: 'root',
})
export class DistributionDataTransformGet extends DataTransformAbstractGet {
  transform(distribution: DistributionInterface): DistributionInterface {
    if (distribution.startAt) {
      distribution.startAt = this.removeUTC(distribution.startAt.toString());
    }
    if (distribution.endAt) {
      distribution.endAt = this.removeUTC(distribution.endAt.toString());
    }
    this.normalizeResources(distribution);
    return distribution;
  }

  private normalizeResources(distribution: DistributionInterface) {
    if (!Array.isArray(distribution.resources)) {
      return this;
    }
    distribution.resources.forEach((resourceInt: PlaylistItemInterface) => {
      this.normalizeTimeslots(resourceInt.timeslots);
      resourceInt.weeklyScheduling = this.normalizeWeeklySchedulings(resourceInt.weeklyScheduling);
      resourceInt.calendarScheduling = this.calendarSchedulings(resourceInt.calendarScheduling);
      this.normalizeNested(resourceInt.nested);
    });
    return this;
  }

  protected calendarSchedulings(calendarScheduling: TimeslotsCalendarInterface[]): TimeslotsCalendarInterface[] {
    if (!Array.isArray(calendarScheduling)) {
      return calendarScheduling;
    }
    calendarScheduling.forEach((calendar) => {
      if (calendar.startAt) {
        calendar.startAt = this.removeUTC(calendar.startAt.toString());
      }
      if (calendar.endAt) {
        calendar.endAt = this.removeUTC(calendar.endAt.toString());
      }
      calendar.weeklySchedulings = this.normalizeWeeklySchedulings(calendar.weeklySchedulings);
      calendar.timeslots = this.normalizeTimeslots(calendar.timeslots);
    });
    return calendarScheduling;
  }

  normalizeNested(nested: PlaylistItemNestedInterface) {
    if (nested) {
      if (!Array.isArray(nested.resources)) {
        return this;
      }
      nested.resources.forEach((resourceInt: PlaylistItemInterface) => {
        // THIS SHOULDN'T EXIST IN NESTED RESOURCES
        this.normalizeTimeslots(resourceInt.timeslots);
      });
    }
  }

  normalizeRange(range: DateRangeInterface[]) {
    if (!Array.isArray(range)) {
      return this;
    }
    range.forEach((rangeItem: DateRangeInterface) => {
      if (rangeItem.startAt) {
        rangeItem.startAt = this.removeUTC(rangeItem.startAt.toString());
      }
      if (rangeItem.endAt) {
        rangeItem.endAt = this.removeUTC(rangeItem.endAt.toString());
      }
    });
  }

  protected normalizeTimeslots(timeslots: TimeslotInterface[]) {
    if (!Array.isArray(timeslots)) {
      return timeslots;
    }
    timeslots.forEach((timeslot: TimeslotInterface) => {
      this.normalizeTimeslot(timeslot);
    });
    return timeslots;
  }

  protected normalizeTimeslot(timeslot: TimeslotInterface): TimeslotInterface {
    if (timeslot.from) {
      timeslot.from = this.removeUTC(timeslot.from.toString());
    }
    if (timeslot.to) {
      timeslot.to = this.removeUTC(timeslot.to.toString());
    }
    return timeslot;
  }

  protected normalizeWeeklySchedulings(weeklyScheduling: WeeklySchedulingInterface[]): WeeklySchedulingInterface[] {
    if (Array.isArray(weeklyScheduling)) {
      weeklyScheduling.forEach((day: WeeklySchedulingInterface) => {
        day.timeslots = this.normalizeTimeslots(day.timeslots);
      });
    }
    return weeklyScheduling;
  }
}
